import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Toast from './Toast';
import BottomButtons from './BottomButtons';
import {Inc,Owner,Book} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    owner:Owner,
	managerId:number,
    book:Book,
    change(book:Book):void,
    close():void,
}

const BookInputBase = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const classes = useStyles();

    const [states,setStates] = useState({
        book: Inc.defaultBook(),
        errors:{"book_name":"","book_name_sub":"","persons":"","history":""},
        toast:"",
        notFound: false,
        isLoading: false,
    });
    const close = ()=>{
        if( states.book.book_id===0 ){
            setStates({...states,notFound:true});
        } else {
            props.close();
        }
    }
	const change = (name: keyof Book) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, book:{...states.book,[name]: event.target.value }});
    };
    const validate = ()=>{
        let errors = {"book_name":"","book_name_sub":"","persons":"","history":""};
        let num = 0;
        if( states.book.book_name==="" ){
            errors["book_name"] = "入力してください";
            num++;
        } else if( states.book.book_name.length>50 ){
            errors["book_name"] = "50文字以内にしてください";
            num++;
        }
        if( states.book.book_name_sub && states.book.book_name_sub.length>50 ){
            errors["book_name_sub"] = "50文字以内にしてください";
            num++;
        }
        if( states.book.persons==="" ){
            errors["persons"] = "入力してください";
            num++;
        }

        if( num>0 ){
            setStates({ ...states, toast:"入力に不備があります", errors:errors});
        } else {
            setStates({ ...states, isLoading:true, errors:errors});
            send();
        }
    }
    const send = ()=>{
        Ajax.send("book/updatea",{
            item_id:props.book.item_id,
            book_name:states.book.book_name,
            book_name_sub:states.book.book_name_sub,
            persons:states.book.persons,
            history:states.book.history,
			manager_id:props.managerId,
        },(res:any)=>{
            if( res.ok ){
                props.change(Inc.convBook(res.book));
            } else {
                setStates({...states,toast:"エラー"});
            }
        });
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
	}


    useEffect( ()=>{
        window.scrollTo(0,0);
        if( props.book.book_id>0 ){
            setStates({...states,book:props.book});
        }

    },[]);

    if( states.notFound ){
        return (
            <Redirect to="/book"/>
        );
    }

    return (
        <div id="book_input_base" className={classes.modalConfirm}>
            <h3 className="bookEditor"><span>A</span>基本情報</h3>
            <Grid container spacing={2} style={{marginTop:"1em"}}>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} fullWidth={true} error={states.errors["book_name"]!==""}>
                        <FormLabel component="label" className={classes.formLabel}>戯曲タイトル<span className="formRequired">必須</span></FormLabel>
                        <TextField
                            id="book_name"
                            value={states.book.book_name}
                            onChange={change('book_name')}
                            margin="dense"
                            variant="outlined"
                        />
                        <div className="hint">50文字以内</div>
                        {states.errors["book_name"]!=="" &&
                        <FormHelperText>{states.errors["book_name"]}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} fullWidth={true} required={false} error={states.errors["book_name_sub"]!==""}>
                        <FormLabel component="label" className={classes.formLabel}>サブタイトル</FormLabel>
                        <TextField
                            id="book_name_sub"
                            value={states.book.book_name_sub}
                            onChange={change('book_name_sub')}
                            margin="dense"
                            variant="outlined"
                        />
                        <div className="hint">50文字以内　省略可　表紙等でタイトルの下に表示されます</div>
                        {states.errors["book_name_sub"]!=="" &&
                        <FormHelperText>{states.errors["book_name_sub"]}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl className={classes.formControl} fullWidth={true} error={states.errors["persons"]!==""}>
                        <FormLabel component="label" className={classes.formLabel}>登場人物一覧<span className="formRequired">必須</span></FormLabel>
                        <TextField
                            id="persons"
                            fullWidth
                            multiline
                            rows="4"
                            value={states.book.persons}
                            onChange={change('persons')}
                            className={classes.textfield}
                            margin="normal"
                            variant="outlined"
                        />
                        <div className="hint">書式は自由　巻頭の「登場人物一覧」のページに表示されます</div>
                        {states.errors["persons"]!=="" &&
                        <FormHelperText>{states.errors["persons"]}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl className={classes.formControl} fullWidth={true} required={false} error={false}>
                        <FormLabel component="label" className={classes.formLabel}>上演記録</FormLabel>
                        <TextField
                            id="history"
                            fullWidth
                            multiline
                            rows="4"
                            value={states.book.history}
                            onChange={change('history')}
                            className={classes.textfield}
                            margin="normal"
                            variant="outlined"
                        />
                        <div className="hint">書式は自由　省略可　巻末の「上演記録」のページに表示されます</div>
                    </FormControl>
                </Grid>
            </Grid>
			<BottomButtons button1='この内容で保存' onClick1={validate} button2='閉じる' onClick2={close}/>
            <Toast close={closeToast} mes={states.toast}/>
            <Loading isLoading={states.isLoading}/>
        </div>
	);
}

export default BookInputBase;
